import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { getAccessToken, saveAccessTokens } from '@ecp/common/src/utils/utils';

import UserInfoProvider from '@mo-components/common/provider/UserInfoProvider';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import GuestRoutes from '@ecp/mo/src/routes/GuestRoutes';
import authApi from '@mo-apis/common/authApi';

const ProtectedRoutes = () => {
  const [checkingToken, setCheckingToken] = useState(!getAccessToken());
  const { isNoMemberUseYn } = useSiteInfo();
  const { pathname, search } = useLocation();

  useEffect(() => {
    let mounted = true;

    const restoreAccessToken = async () => {
      if (getAccessToken()) {
        setCheckingToken(false);
        return;
      }

      try {
        const {
          data: {
            result: { accessToken },
          },
        } = await authApi.reissue();

        if (accessToken) {
          saveAccessTokens(accessToken);
        }
      } catch (e) {
        // refresh token cookie가 없거나 만료된 경우 기존 미로그인 라우팅으로 진행한다.
      } finally {
        if (mounted) {
          setCheckingToken(false);
        }
      }
    };

    restoreAccessToken();

    return () => {
      mounted = false;
    };
  }, []);

  const notLoggedInRoutes = () => {
    switch (isNoMemberUseYn) {
      case true:
        return <GuestRoutes />;
      case false:
        return <Navigate to="/login" state={{ prev: pathname + search, current: '/login' }} />;
      default:
        return <></>;
    }
  }

  if (checkingToken) {
    return <></>;
  }

  return getAccessToken() ? (
    <UserInfoProvider>
      <Outlet />
    </UserInfoProvider>
  ) : (notLoggedInRoutes());
};

export default ProtectedRoutes;
